import React from 'react';
import Helmet from 'react-helmet';

import { ClientBasedConfigLayoutConstants } from '../../constants/clientBasedLoginConstant';
import ClientConfigDetail from '../../stores/models/ClientConfigDetailModel';
import {
  UserAuthHandlerMachineSendType,
  UserAuthHandlerMachineStateType
} from '../../types/UserAuthHandlerMachineTypes';

import { AuthFormSection } from '../AuthFormSection';
import { ClientBasedDescriptionSection } from '../ClientBasedDescriptionSection';

import {
  ClientBasedAuthPageMainContainer,
  CustomStylesContainer
} from './styledComponents';

interface ClientBasedAuthPageUIProps {
  userAuthHandlerMachineState: UserAuthHandlerMachineStateType;
  userAuthHandlerMachineSend: UserAuthHandlerMachineSendType;
  clientConfigDetails: ClientConfigDetail;
}

const ClientBasedAuthPageUI: React.FC<ClientBasedAuthPageUIProps> = ({
  userAuthHandlerMachineSend,
  userAuthHandlerMachineState,
  clientConfigDetails
}) => {
  const { customStyles, layOutType, seoLink, seoMetaData, seoTitle } =
    clientConfigDetails;

  const renderSeoInfo = () => {
    const meta = [...seoMetaData];
    const linkData = [...seoLink];
    return <Helmet title={seoTitle} meta={meta} link={linkData} />;
  };

  const renderAuthFormSection = () => {
    return (
      <AuthFormSection
        userAuthHandlerMachineSend={userAuthHandlerMachineSend}
        userAuthHandlerMachineState={userAuthHandlerMachineState}
        clientConfigDetails={clientConfigDetails}
      />
    );
  };

  const renderClientBasedDescriptionSection = () => {
    return (
      <ClientBasedDescriptionSection
        content={clientConfigDetails.brandingSectionMarkdownContent}
      />
    );
  };
  const renderLeftSection = () => {
    if (
      layOutType ===
      ClientBasedConfigLayoutConstants.LOGIN_SECTION_RIGHT_BRANDING_SECTION_LEFT
    ) {
      return renderClientBasedDescriptionSection();
    }
    return renderAuthFormSection();
  };
  const renderRightSection = () => {
    if (
      layOutType ===
      ClientBasedConfigLayoutConstants.LOGIN_SECTION_RIGHT_BRANDING_SECTION_LEFT
    ) {
      return renderAuthFormSection();
    } else if (
      layOutType ===
      ClientBasedConfigLayoutConstants.LOGIN_SECTION_LEFT_BRANDING_SECTION_RIGHT
    ) {
      return renderClientBasedDescriptionSection();
    } else return null;
  };

  return (
    <CustomStylesContainer customStyles={customStyles}>
      <ClientBasedAuthPageMainContainer className="client-based-auth-page-main-container">
        {renderLeftSection()}
        {renderRightSection()}
        {renderSeoInfo()}
      </ClientBasedAuthPageMainContainer>
    </CustomStylesContainer>
  );
};

export { ClientBasedAuthPageUI };
